import { useDeusExMachina } from '~/domains/platform/infra/deus-ex-machina/hocs/with-deus-ex-machina'

import { useIsOneStone } from './use-is-one-stone'

export function useIsUserStoneNew() {
  const isOneStone = useIsOneStone()
  const { deusExMachina } = useDeusExMachina()
  const originBrand = deusExMachina?.entity.stoneAccount?.originBrand
  return isOneStone && !originBrand
}
